/**
 * Port of student-app normalizeAiToolsProfile degree helpers.
 * Keep algorithm identical — do not simplify.
 */
export function parseCountries(value) {
  if (Array.isArray(value)) return value;
  if (!value) return [];
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return [];
    if (trimmed.startsWith('[')) {
      try {
        const parsed = JSON.parse(trimmed);
        return Array.isArray(parsed) ? parsed : [trimmed];
      } catch {
        return trimmed
          .split(',')
          .map(item => item.trim())
          .filter(Boolean);
      }
    }
    if (trimmed.includes(',')) {
      return trimmed
        .split(',')
        .map(item => item.trim())
        .filter(Boolean);
    }
    return [trimmed];
  }
  return [];
}

function getDegreeLevel(levelCat) {
  if (!levelCat) return null;
  return levelCat === 'HighSchool' ? 'Bachelors' : 'Masters';
}

function getHighestLevel(levelCat) {
  if (!levelCat) return null;
  return levelCat === 'Masters' ? 'Bachelors' : levelCat;
}

export function deriveDegreeFields(profile = {}, { isStudent } = {}) {
  const highestLevel = profile.highestLevel || '';
  const next = { ...profile };

  if (isStudent === true) {
    next.highestLevel = highestLevel || 'HighSchool';
    next.highestLevelOfEducation = 'HighSchool';
    next.activeDegree = 'Bachelors';
  } else if (isStudent === false) {
    if (highestLevel) {
      next.highestLevelOfEducation = getHighestLevel(highestLevel) || next.highestLevelOfEducation || '';
      next.activeDegree = getDegreeLevel(highestLevel) || next.activeDegree || '';
    }
  } else if (highestLevel === 'HighSchool') {
    next.highestLevel = highestLevel;
    next.highestLevelOfEducation = next.highestLevelOfEducation || 'HighSchool';
    next.activeDegree = next.activeDegree || 'Bachelors';
  } else if (highestLevel) {
    next.highestLevelOfEducation = next.highestLevelOfEducation || getHighestLevel(highestLevel) || '';
    next.activeDegree = next.activeDegree || getDegreeLevel(highestLevel) || '';
  }

  if (!next.degreeTitle && next.subCategory) {
    next.degreeTitle = next.subCategory;
  }

  return next;
}

export function normalizeAiToolsProfile(profile = {}, options = {}) {
  const parsed = {
    ...profile,
    countries: parseCountries(profile.countries),
  };
  return deriveDegreeFields(parsed, options);
}

/** Merge shortlist query (+ optional draft) and derive degree fields. Student parity. */
export function normalizeShortlistQuery(query = {}, { savedDataAiTools, isStudent } = {}) {
  const merged = {
    ...(savedDataAiTools || {}),
    ...query,
    countries: parseCountries(query.countries ?? savedDataAiTools?.countries),
  };
  return deriveDegreeFields(merged, { isStudent });
}
